// Checkbox styles

import styled from 'styled-components';
import Icon from 'components/Icon';

import {
  fieldRadioCheckStyles,
  labelStyles,
  pseudoRadioCheck,
  inputRadioCheck,
} from '../shared';

export const FieldStyled = styled.div`
  ${fieldRadioCheckStyles}
`;

export const LabelStyled = styled.label`
  ${labelStyles}
  &::before {
    ${pseudoRadioCheck}
    border-radius: ${props => props.theme.borderRadius.xsmall};
  }
  &::before {
    border: 1px solid ${props => props.theme.color.wfGrey400};
  }
`;
export const IconStyled = styled(Icon)`
  color: ${props => props.theme.color.wfWhite};
  transform: scale(0.6);
  position: absolute;
  left: 0;
  opacity: 0;
`;

export const InputStyled = styled.input`
  ${inputRadioCheck}
  &:checked {
    ~ ${LabelStyled} {
      &::before {
        border-color: ${props => props.theme.color.primary};
        background-color: ${props => props.theme.color.primary};
      }
      ${IconStyled} {
        opacity: 1;
      }
    }
  }
  &:disabled {
    cursor: not-allowed;
    ~ ${LabelStyled} {
      cursor: not-allowed;
      color: ${props => props.theme.color.wfGrey300};
      &::before {
        border-color: currentColor;
        background-color: currentColor;
      }
    }
  }
`;
